// Ported from oai-realtime-with-twilio/packages/disposition-engine-gui/src/field_metadata.ts
// when that package is published, swap this file for a direct import.

export const PLACEHOLDERS: Record<string, string> = {
  plan_status: 'PLAN_STATUS_ACTIVE',
  drug_coverage_info: 'COVERED',
  plan_type: 'POLICY_TYPE_COMMERCIAL',
  is_prior_authorization_required: 'yes',
  is_prior_authorization_on_file: 'yes',
  prior_authorization_submission_methods: 'phone, fax',
};

const FIELD_LABELS: Record<string, string> = {
  plan_status: 'Plan status',
  drug_coverage_info: 'Drug coverage',
  plan_type: 'Plan type',
  is_prior_authorization_required: 'Prior auth required?',
  is_prior_authorization_on_file: 'Prior auth on file?',
  member_not_found: 'Member not found',
  member_info_mismatch: 'Member info mismatch',
  needs_live_human: 'Needs live human',
  third_party_pushback: 'Third party pushback',
  is_system_under_maintenance: 'System under maintenance',
  call_made_after_working_hours: 'After working hours',
  pbm_carveout: 'PBM carveout',
  provider_info_mismatch: 'Provider info mismatch',
  provider_info_missing: 'Provider info missing',
  tax_id_required: 'Tax ID required',
  provider_authentication_required: 'Provider authentication required',
  payer_no_recording_policy: 'Payer no-recording policy',
  wrong_phone_number: 'Wrong phone number',
  wrong_payer_department: 'Wrong payer department',
  check_alternate_way_for_verification: 'Check alternate way for verification',
  provider_not_active: 'Provider not active',
  benefits_already_released: 'Benefits already released',
  no_medical_coverage: 'No medical coverage',
  eligibility_update_pending: 'Eligibility update pending',
  prior_authorization_submission_methods: 'PA submission methods',
  eligibility_status: 'Eligibility status',
  coverage_for_drug: 'Drug coverage',
  coverage_for_procedure: 'Procedure coverage',
  prior_authorization_required_for_drug: 'Prior auth required for drug',
  prior_authorization_on_file_for_drug: 'Prior auth on file for drug',
  copay_for_drug: 'Drug copay',
  deductible_applies_for_drug: 'Deductible applies for drug',
  referral_required: 'Referral required',
  referral_on_file: 'Referral on file',
  referral_visits_total_approved: 'Referral visits approved',
  insurance_representative_name: 'Insurance rep name',
  call_reference_number: 'Call reference number',
};

export function labelForField(fieldKey: string): string {
  return FIELD_LABELS[fieldKey] ?? fieldKey;
}
